<div class="container-fluid">
  <div class="row">
    <div class="col-sm-12">
      <div class="page-header">
        <div class="flex-row filter-row">
          <a href="https://zoom.us/j/7337417607?pwd=L21yTkcyOUdFZkpYck1Vc1VIc0dDZz09"
             class="btn btn-default ng-star-inserted" target="_blank" matTooltip="Open zoom in new page">
            <i class="fa fa-external-link-alt ng-star-inserted">&nbsp;</i>Open Zoom
          </a>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-12">
      <div class="card last">
        <div class="card-body grid" [style.height]="gridHeight">
          <div class="progress-wrapper" *ngIf="isLoading" [ngClass]="{'is-loading' : isLoading}">
            <span class="k-i-loading k-icon"></span>
          </div>
          <div class="error-wrapper" *ngIf="hasError" [ngClass]="{'has-error' : hasError}">
            <span class="error-description">

            </span>
          </div>
          <iframe [src]="zoomUrl" width="100%" height="100%" frameborder="0" allow="camera; microphone; speaker"></iframe>
        </div>
      </div>
    </div>
  </div>
</div>
